import type {MouseEvent} from 'react';
import {useCallback} from 'react';
import type {NativeSyntheticEvent, NativeTouchEvent} from 'react-native';

import type {ThemeColor} from '../../styles/theme';
import type {Props} from './types';

import {createEventNormalizer} from '../../utils/events';
import {useTimeBlockedCallback} from '../../utils/hooks/useTimeBlockedCallback';
import {cScheme, sizeScheme} from './styles';

export const useController = ({onClick, scheme, size}: Required<Props>) => {
  const clickHandler = useTimeBlockedCallback(
    useCallback(
      event => {
        const normalized = clickEventNormalizer(event);

        onClick?.(normalized);
      },
      [onClick],
    ),
  );

  const loaderStroke = cScheme[scheme].secondary as ThemeColor;

  const loaderSize = sizeScheme[size];

  return {clickHandler, loaderSize, loaderStroke};
};

const clickEventNormalizer = createEventNormalizer<
  MouseEvent,
  NativeSyntheticEvent<NativeTouchEvent>,
  null
>();
